import { EquatorialCoord, deg2rad, rad2deg } from '@hscmap/angle';
import { Bridge } from "..";
import { waitForImageLoad } from '@/modules/JupyterModule';
import { ICallback } from './callback';
import { canvasDafeDatUrl } from '@/utils/canvas';
import { time } from '@/utils/time';

interface IPostageStamp {
  type: 'postage_stamp'
  args: {
    ra: number
    dec: number
    fov: number,
    callback: ICallback,
  }
}

export async function postage_stamp(b: Bridge, msg: IPostageStamp) {
  const { ra, dec, fov } = msg.args
  const fovRad = deg2rad(fov)
  b.jupyterGlobe.viewFactory.jumpTo({ fovy: fovRad }, { coord: EquatorialCoord.fromDeg(ra, dec), duration: 1 })
  await time.sleep(17)
  await waitForImageLoad(b.jupyterGlobe)
  const url = canvasDafeDatUrl(b.jupyterGlobe.canvas.domElement)
  b.callback(msg.args.callback, [url])
}
